(function () {
  "use strict";

  /* ---------- Mobile nav ---------- */
  var mobileNav = document.getElementById("MobileNav");
  document.querySelectorAll("[data-mobile-nav-open]").forEach(function (btn) {
    btn.addEventListener("click", function () { if (mobileNav) mobileNav.setAttribute("open", ""); });
  });
  document.querySelectorAll("[data-mobile-nav-close]").forEach(function (btn) {
    btn.addEventListener("click", function () { if (mobileNav) mobileNav.removeAttribute("open"); });
  });

  /* ---------- Search toggle ---------- */
  var headerSearch = document.getElementById("HeaderSearch");
  document.querySelectorAll("[data-search-toggle]").forEach(function (btn) {
    btn.addEventListener("click", function () {
      if (!headerSearch) return;
      headerSearch.hidden = !headerSearch.hidden;
      if (!headerSearch.hidden) {
        var input = headerSearch.querySelector("input[type=search]");
        if (input) input.focus();
      }
    });
  });

  /* ---------- Cart drawer ---------- */
  var cartDrawer = document.getElementById("CartDrawer");
  function openCartDrawer() { if (cartDrawer) cartDrawer.setAttribute("open", ""); }
  function closeCartDrawer() { if (cartDrawer) cartDrawer.removeAttribute("open"); }
  document.querySelectorAll("[data-cart-drawer-open]").forEach(function (btn) {
    btn.addEventListener("click", openCartDrawer);
  });
  document.querySelectorAll("[data-cart-drawer-close]").forEach(function (btn) {
    btn.addEventListener("click", closeCartDrawer);
  });

  function updateCartCount(count) {
    document.querySelectorAll(".cart-count").forEach(function (el) { el.textContent = count; });
  }

  function refreshCartDrawer() {
    fetch("/cart.js")
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        updateCartCount(cart.item_count);
        var subtotalEl = document.getElementById("CartDrawerSubtotal");
        if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);
      });
  }

  function formatMoney(cents) {
    return "R " + (cents / 100).toFixed(2);
  }

  /* ---------- Add to cart (product form) ---------- */
  document.querySelectorAll('form[action^="/cart/add"]').forEach(function (form) {
    form.addEventListener("submit", function (e) {
      e.preventDefault();
      var formData = new FormData(form);
      var submitBtn = form.querySelector('button[type="submit"]');
      if (submitBtn) submitBtn.disabled = true;

      fetch("/cart/add.js", {
        method: "POST",
        headers: { Accept: "application/json" },
        body: formData,
      })
        .then(function (r) { return r.json(); })
        .then(function () {
          refreshCartDrawer();
          openCartDrawer();
          window.location.reload();
        })
        .catch(function (err) { console.error(err); })
        .finally(function () { if (submitBtn) submitBtn.disabled = false; });
    });
  });

  /* ---------- Cart quantity +/- , remove (drawer & cart page) ----------
   The cart updates in place, so the slide-out cart stays open. */
  var cartBusy = false;

  function setCartCount(n) {
    var els = document.querySelectorAll(".cart-count");
    if (els.length) {
      els.forEach(function (el) { if (n > 0) el.textContent = n; else el.remove(); });
    } else if (n > 0) {
      var btn = document.querySelector("[data-cart-drawer-open]");
      if (btn) { var span = document.createElement("span"); span.className = "cart-count"; span.textContent = n; btn.appendChild(span); }
    }
  }

  // Re-read the current page and swap in the fresh cart markup (drawer, cart page, count)
  function refreshCartViews() {
    return Promise.all([
      fetch("/cart.js").then(function (r) { return r.json(); }),
      fetch(window.location.pathname + window.location.search, { credentials: "same-origin" }).then(function (r) { return r.text(); }),
    ]).then(function (res) {
      var cart = res[0];
      var doc = new DOMParser().parseFromString(res[1], "text/html");
      var items = document.getElementById("CartDrawerItems");
      var newItems = doc.getElementById("CartDrawerItems");
      if (items && newItems) items.innerHTML = newItems.innerHTML;
      var sub = document.getElementById("CartDrawerSubtotal");
      var newSub = doc.getElementById("CartDrawerSubtotal");
      if (sub && newSub) sub.innerHTML = newSub.innerHTML;
      if (window.location.pathname === "/cart") {
        var main = document.getElementById("MainContent");
        var newMain = doc.getElementById("MainContent");
        if (main && newMain) main.innerHTML = newMain.innerHTML;
      }
      setCartCount(cart.item_count);
    });
  }

  function runCartChange(request) {
    if (cartBusy) return;
    cartBusy = true;
    document.body.classList.add("cart-busy");
    request()
      .then(refreshCartViews)
      .catch(function (err) { console.error(err); })
      .then(function () { cartBusy = false; document.body.classList.remove("cart-busy"); });
  }

  function changeCartLine(line, quantity) {
    runCartChange(function () {
      return fetch("/cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ line: Number(line), quantity: quantity }),
      });
    });
  }

  function stepCartLine(btn, delta) {
    var box = btn.parentElement ? btn.parentElement.querySelector("[data-cart-qty-input]") : null;
    var current = box ? parseInt(box.value, 10) || 0 : 0;
    changeCartLine(btn.getAttribute("data-line"), Math.max(0, current + delta));
  }

  document.addEventListener("click", function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var inc = t.closest("[data-cart-qty-increase]");
    if (inc) { e.preventDefault(); stepCartLine(inc, 1); return; }
    var dec = t.closest("[data-cart-qty-decrease]");
    if (dec) { e.preventDefault(); stepCartLine(dec, -1); return; }
    var removeSet = t.closest("[data-cart-remove-set]");
    if (removeSet) {
      e.preventDefault();
      var updates = {};
      (removeSet.getAttribute("data-keys") || "").split(",").forEach(function (key) { if (key) updates[key] = 0; });
      runCartChange(function () {
        return fetch("/cart/update.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ updates: updates }),
        });
      });
      return;
    }
    var remove = t.closest("[data-cart-remove]");
    if (remove) { e.preventDefault(); changeCartLine(remove.getAttribute("data-line"), 0); }
  });

  /* ---------- Product quantity stepper ---------- */
  var qtyInput = document.getElementById("ProductQuantity");
  var qtyIncrease = document.querySelector("[data-qty-increase]");
  var qtyDecrease = document.querySelector("[data-qty-decrease]");
  if (qtyInput && qtyIncrease && qtyDecrease) {
    qtyIncrease.addEventListener("click", function () { qtyInput.value = parseInt(qtyInput.value, 10) + 1; });
    qtyDecrease.addEventListener("click", function () {
      qtyInput.value = Math.max(1, parseInt(qtyInput.value, 10) - 1);
    });
  }

  /* ---------- Product gallery thumbnails ---------- */
  var mainImage = document.getElementById("ProductMainImage");
  document.querySelectorAll("[data-thumb]").forEach(function (thumb) {
    thumb.addEventListener("click", function () {
      document.querySelectorAll("[data-thumb]").forEach(function (t) { t.classList.remove("active"); });
      thumb.classList.add("active");
      if (mainImage) mainImage.src = thumb.getAttribute("data-full");
    });
  });

  /* ---------- Variant swatches ---------- */
  var variantSelect = document.getElementById("ProductVariantSelect");
  var swatches = document.querySelectorAll(".variant-swatch");
  var selectedOptions = {};

  function syncSwatchesFromSelect() {
    if (!variantSelect) return;
    var selectedText = variantSelect.options[variantSelect.selectedIndex].text.trim();
    selectedOptions = {};
    selectedText.split(" / ").forEach(function (val, idx) { selectedOptions[idx] = val.trim(); });
    swatches.forEach(function (sw) {
      var idx = sw.getAttribute("data-option-index");
      sw.classList.toggle("selected", selectedOptions[idx] === sw.getAttribute("data-value"));
    });
  }
  syncSwatchesFromSelect();

  swatches.forEach(function (swatch) {
    swatch.addEventListener("click", function () {
      var idx = swatch.getAttribute("data-option-index");
      selectedOptions[idx] = swatch.getAttribute("data-value");

      var values = [];
      var maxIdx = Math.max.apply(null, Array.from(swatches).map(function (s) { return parseInt(s.getAttribute("data-option-index"), 10); }));
      for (var i = 0; i <= maxIdx; i++) { values.push(selectedOptions[i]); }
      var targetTitle = values.join(" / ");

      if (variantSelect) {
        for (var j = 0; j < variantSelect.options.length; j++) {
          if (variantSelect.options[j].text.trim().indexOf(targetTitle) === 0) {
            variantSelect.selectedIndex = j;
            break;
          }
        }
      }
      syncSwatchesFromSelect();
    });
  });
})();
